import { useEffect, useMemo, useState } from 'react';

// mise à jour du draft lorsque le ticket est refetch (mutateTicket)
export const useSetDraft = ({
  ticket,
  recipientType,
  ticketValidating = false,
}) => {
  const [isDraftSet, setIsDraftSet] = useState(false);
  const [draft, setDraft] = useState(null);
  const [lastTicketVersion, setLastTicketVersion] = useState(null);

  const ticketHasChanged = useMemo(() => {
    if (!ticket || !lastTicketVersion) return true;
    return (
      ticket.contactDraft?._id !== lastTicketVersion.contactDraft?._id ||
      ticket.serviceProviderDraft?._id !==
        lastTicketVersion.serviceProviderDraft?._id ||
      ticket.contactDraft?.updatedAt !==
        lastTicketVersion.contactDraft?.updatedAt ||
      ticket.serviceProviderDraft?.updatedAt !==
        lastTicketVersion.serviceProviderDraft?.updatedAt
    );
  }, [ticket, lastTicketVersion]);

  useEffect(() => {
    if (ticketValidating && !ticketHasChanged) return;
    if (!recipientType) return;
    if (!ticket) return;

    const draftMapping = {
      CONTACT: ticket?.contactDraft,
      SERVICEPROVIDER: ticket?.serviceProviderDraft,
    };
    const draftToUse = draftMapping[recipientType] || null;

    const shouldUpdate =
      draft?._id !== draftToUse?._id ||
      draft?.updatedAt !== draftToUse?.updatedAt;

    if (shouldUpdate || !isDraftSet) {
      setDraft(draftToUse);
      setLastTicketVersion(ticket);
      setIsDraftSet(true);
    }
  }, [recipientType, ticket, ticketValidating, ticketHasChanged, isDraftSet]);

  useEffect(() => {
    if (ticketValidating) {
      console.log('useSetDraft ticket validationg', isDraftSet);
      setIsDraftSet(false);
    }
  }, [ticketValidating]);

  return {
    isDraftSet,
    draft,
  };
};
